(function () {
  function init(bar) {
    var slides = Array.prototype.slice.call(bar.querySelectorAll('.announcement-bar__vslide'));
    if (slides.length < 2) return;

    var prevBtn = bar.querySelector('[data-announcement-prev]');
    var nextBtn = bar.querySelector('[data-announcement-next]');
    var current = 0;
    var timer;
    var speed = (parseFloat(bar.dataset.speed) || 5) * 1000;
    var autoplay = bar.dataset.autoplay === 'true';
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function goTo(index) {
      var next = (index + slides.length) % slides.length;
      if (next === current) return;

      var currentSlide = slides[current];
      var nextSlide = slides[next];

      currentSlide.classList.remove('is-active');
      currentSlide.classList.add('is-leaving');
      currentSlide.setAttribute('aria-hidden', 'true');

      nextSlide.classList.add('is-active');
      nextSlide.removeAttribute('aria-hidden');

      setTimeout(function () {
        currentSlide.classList.remove('is-leaving');
      }, reduceMotion ? 0 : 550);

      current = next;
    }

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    function stop() {
      clearInterval(timer);
      timer = null;
    }

    function start() {
      if (!autoplay || timer) return;
      timer = setInterval(next, speed);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        stop();
        start();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        stop();
        start();
      });
    }

    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);

    start();
  }

  function initAll() {
    document.querySelectorAll('.announcement-bar--vertical').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
